import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import ProjectClientPageContent from '@shared/components/organization/projects/client/ProjectClientPageContent';
import useCurrentOrgProjectsFetching from '@shared/hooks/useCurrentOrgProjectsFetching';
import { useTranslation } from 'react-i18next';

export default function ProjectClientDetailPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrgClient } = useCurrentOrgProjectsFetching();

    return (
        <>
            <PageHeader
                title={currentOrgClient?.name ?? t('common:organization.projects.clients.title')}
                description={t('common:organization.projects.clients.description')}
                items={items}
            />
            <ProjectClientPageContent />
        </>
    );
}
